import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../utils/handleError';
import i18next from 'i18next';
import { ReceivedVoucherApi } from './ReceivedVoucherApi';
import Dict from '../../utils/Dict';
import { ROLES } from '../../_helpers/Constants';

export const receivedVoucherModule = 'receivedVoucher';

const LOADING_TABLE = `${receivedVoucherModule}/LOADING_TABLE`;
const TABLE_DATA = `${receivedVoucherModule}/TABLE_DATA`;
const CLEAR_STATE = `${receivedVoucherModule}/CLEAR_STATE`;

const initialState = {
  loadingTable: false,
  tableData: {
    content: [],
    totalElements: 0
  },
  pageNumber: 1
};
export default createReducer(initialState, {
  [LOADING_TABLE]: (state, action) => {
    state.loadingTable = action.payload;
  },
  [TABLE_DATA]: (state, action) => {
    state.tableData = {
      content:
        action.pageNumber === 1
          ? action.data
          : [...state.tableData.content, ...action.data],
      totalElements: action.totalElements
    };
    state.pageNumber = action.pageNumber;
  },
  [CLEAR_STATE]: () => initialState
});

export const clearState = () => ({ type: CLEAR_STATE });

export const loadTableData = filter => async (dispatch, getState) => {
  try {
    dispatch({ type: LOADING_TABLE, payload: true });
    const userProfile = { ...getState().login.user };
    if (userProfile) {
      const roles = userProfile.roles || [];

      const isGod = roles.includes(ROLES.ES_GODS);
      const hasServiceProviderRole =
        roles.includes(ROLES.ES_SERVICE_PROVIDER_EMPLOYEES) ||
        roles.includes(ROLES.ES_SERVICE_PROVIDER_HEADS) ||
        roles.includes(ROLES.ES_REGION_MIO_EMPLOYEES);
      if (!isGod && hasServiceProviderRole) {
        filter['serviceProviderId'] = userProfile?.organization_id;
      }
    }

    let { data } = await ReceivedVoucherApi.loadVouchers(JSON.stringify({ ...filter }));

    const content = [];

    for (let item of data.content) {
      let queuedType = item.queuedType
        ? await Dict.item('gu_queued_type', item.queuedType || '')
        : '';
      let appStatusWeb = item.status
        ? await Dict.item('voucher_status_web', item.status || '')
        : '';
      let queuedRegion = item.queuedRegion
        ? await Dict.item('60', item.queuedRegion || '')
        : '';
      let ageGroup = item.ageGroup
        ? await Dict.item('gu_age_group', item.ageGroup || '')
        : '';

      content.push({
        ...item,
        queuedType: queuedType,
        appStatusWebStatus: appStatusWeb,
        queuedRegion: queuedRegion,
        ageGroup:ageGroup
      });
    }

    dispatch({
      type: TABLE_DATA,
      data: content,
      pageNumber: data.pageNumber,
      totalElements: data.totalElements
    });

  } catch (error) {
    handleError(error, i18next.t('receivedVoucher_errorLoadTable'));
  } finally {
    dispatch({ type: LOADING_TABLE, payload: false });
  }
};
